import React, { Component } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { NavLink, HashRouter } from "react-router-dom";
import Phone from "./pictures/phone-icon.png";
import Mail from "./pictures/mail-icon.png";

class Menu extends Component {
  render() {
    const styles = {
      borderRadius: "3px",
      margin: "0",
      width: "100%",
      top: 0,
      position: "sticky",
    };
    return (
      <HashRouter>
        <div style={styles}>
          <Navbar className="main white nav-margins" bg="light" expand="lg">
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link>
                  <NavLink to="/" className="Links">
                    Home
                  </NavLink>
                </Nav.Link>
                <Nav.Link>
                  <NavLink to="/services" className="Links">
                    Dienstleistungen & Preise
                  </NavLink>
                </Nav.Link>
                {/* <Nav.Link>
                  <NavLink to="/products" className="Links">
                    Produkte
                  </NavLink>
                </Nav.Link> */}
                <Nav.Link>
                  <NavLink to="/appointment" className="Links">
                    Termine & Kontakt
                  </NavLink>
                </Nav.Link>
                <Nav.Link>
                  <NavLink to="/about" className="Links">
                    Über mich
                  </NavLink>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </HashRouter>
    );
  }
}

export default Menu;
